const experts = () => {
    
    var carousel = $(".experts-slider")
    
    if(carousel.length > 0) {
        
        $(carousel).slick({
            mobileFirst: true,
            arrows: false,
            slidesToShow: 1,
            variableWidth: true,
            infinite: false,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    arrows: true,
                    prevArrow: '<button type="button" class="slick-prev"></button>',
                    nextArrow: '<button type="button" class="slick-next"></button>',  
                  }
                }
            ]
        })
        
    }
}

const expertsList = () => {

    var container = $("#experts_list")
    var items = $("#experts_list").find(".item")
    
    if (container.length > 0) {
        if (items.length > 2) {
            items.each(function(index){
                if (index >=2) {
                    $(this).css('display', 'none')
                }
            })
            
            $("#more-experts-container").css("display","table")
                
            function handler1() {
                items.each(function(index){
                    if (index >=2) {
                        $(this).css('display', 'block')
                    }
                })
                
                $("#more-experts span").text("Zwiń")

                $(this).one("click", handler2);
            }

            function handler2() {
                items.each(function(index){
                    if (index >=2) {
                        $(this).css('display', 'none')
                    }
                })
                
                $("#more-experts span").text("Wszyscy eksperci")
                
                $(this).one("click", handler1);
            }
            $("#more-experts").one("click", handler1);

        }
    }
}

const loadMoreExperts = function(){
    var load_more_experts_btn = $('#load-more-experts');
    load_more_experts_btn.on('click', function(e){

        e.preventDefault();

        var list = $('#experts-list'),
            offset = list.find('.expert').length;
        
        $.ajax({
            url: "/ajax/get-experts",
            type: 'POST',
            data: {
                offset: offset
            },
            dataType: "json",
            success: function (data) { 

                if( data.length === 0 ){
                    load_more_experts_btn.hide();
                }

                $.each( data, function( key ) {

                    var id = data[key].id,
                        firstname = data[key].firstname,
                        lastname = data[key].lastname,
                        bio = data[key].bio,
                        title = data[key].title,
                        avatar = data[key].avatar,
                        route = data[key].route;

                        if(title === null){
                            title = '';
                        }

                    list.append('<a href="ekspert/'+route+'" class="item expert"><div class="img-box"><img src="'+avatar+'" alt="'+firstname+' '+lastname+'"></div><h2 class="name"><span class="thin">'+title+'</span>'+firstname+' '+lastname+'</h2></a>');
                });

            },
            error: function (error) { console.log('error'); }
        });

    });
}

module.exports = {
    experts,
    expertsList,
    loadMoreExperts
};